import { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";

export default function ChartLine({
  theme = "light",
  data = {},
  view = "diario",
  type = "ventas", // 👈 nuevo parámetro
}) {
  // Preparamos los datos según la vista seleccionada
  const { labels, values, title } = useMemo(() => {
    if (!data || !Array.isArray(data[view])) {
      return { labels: [], values: [], title: "Sin datos disponibles" };
    }

    let labels = [];
    let values = [];
    const field = type === "compras" ? "totalCompras" : "totalVentas"; // 👈 detecta campo correcto
    const labelPrefix = type === "compras" ? "Compras" : "Ventas";

    switch (view) {
      case "diario":
        labels = data.diario.map((item) => item.fecha.split(" ")[0]);
        values = data.diario.map((item) => item[field] ?? 0);
        return { labels, values, title: `${labelPrefix} diarias` };

      case "semanal":
        labels = data.semanal.map(
          (item) =>
            `${item.semanaInicio.split(" ")[0]} - ${
              item.semanaFin.split(" ")[0]
            }`
        );
        values = data.semanal.map((item) => item[field] ?? 0);
        return { labels, values, title: `${labelPrefix} semanales` };

      case "mensual":
        labels = data.mensual.map((item) => `${item.nombreMes} ${item.anio}`);
        values = data.mensual.map((item) => item[field] ?? 0);
        return { labels, values, title: `${labelPrefix} mensuales` };

      default:
        return { labels: [], values: [], title: "Sin datos" };
    }
  }, [data, view, type]);

  const option = {
    title: {
      text: title,
      left: "center",
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
        color: theme === "dark" ? "#fff" : "#333",
      },
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: theme === "dark" ? "#333" : "#fff",
      borderColor: "#ccc",
      borderWidth: 1,
      textStyle: { color: theme === "dark" ? "#fff" : "#333" },
    },
    toolbox: {
      show: true,
      orient: "horizontal",
      feature: {
        saveAsImage: { show: true, title: "Guardar PNG" },
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ["line", "bar"] },
        restore: { show: true },
        dataZoom: { show: true },
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: labels,
      axisLine: {
        lineStyle: { color: theme === "dark" ? "#aaa" : "#333" },
      },
      axisLabel: { color: theme === "dark" ? "#ccc" : "#333", rotate: 45 },
    },
    yAxis: {
      type: "value",
      splitLine: {
        lineStyle: { color: theme === "dark" ? "#444" : "#eee" },
      },
      axisLabel: { color: theme === "dark" ? "#ccc" : "#333" },
    },
    series: [
      {
        name: title,
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 6,
        showSymbol: false,
        lineStyle: { width: 2 },
        areaStyle: { opacity: 0.3 },
        data: values,
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      theme={theme}
      style={{ height: "300px", width: "100%" }} // 👈 mantiene tu tamaño original
    />
  );
}

ChartLine.propTypes = {
  theme: PropTypes.string,
  data: PropTypes.object,
  view: PropTypes.oneOf(["diario", "semanal", "mensual"]),
  type: PropTypes.oneOf(["ventas", "compras"]), // 👈 nuevo prop
};
